module.exports = __webpack_public_path__ + "fa-solid-900.1d220cf9da36861171fa.svg";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-solid-900.svg
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-solid-900.svg
// module chunks = styles